import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-slate-900" }
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 py-6" }
const _hoisted_3 = {
  class: "relative overflow-hidden rounded-2xl mb-8",
  style: {"background":"linear-gradient(135deg, #EA580C 0%, #DC2626 50%, #B91C1C 100%)"}
}
const _hoisted_4 = { class: "relative p-8" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "text-2xl font-bold text-white" }
const _hoisted_7 = { class: "text-white/90 text-lg font-medium" }
const _hoisted_8 = { class: "mb-8" }
const _hoisted_9 = { class: "bg-white dark:bg-slate-800 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-slate-700" }
const _hoisted_10 = { class: "p-6" }
const _hoisted_11 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_12 = { class: "text-xl font-semibold text-slate-900 dark:text-white" }
const _hoisted_13 = { class: "text-slate-600 dark:text-slate-300" }
const _hoisted_14 = { class: "space-y-3" }
const _hoisted_15 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = ["type", "placeholder"]
const _hoisted_18 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_19 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_21 = { class: "space-y-3" }
const _hoisted_22 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_23 = { class: "relative" }
const _hoisted_24 = ["type", "placeholder"]
const _hoisted_25 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_26 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_27 = { class: "space-y-3" }
const _hoisted_28 = { class: "block text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_29 = { class: "relative" }
const _hoisted_30 = ["type", "placeholder"]
const _hoisted_31 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_32 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_33 = {
  key: 0,
  class: "text-sm text-red-600 dark:text-red-400 flex items-center gap-2 bg-red-50 dark:bg-red-900/20 p-2 rounded-lg"
}
const _hoisted_34 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_35 = {
  key: 0,
  class: "p-4 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-400 rounded-xl border border-emerald-200 dark:border-emerald-800"
}
const _hoisted_36 = { class: "flex items-center gap-3" }
const _hoisted_37 = { class: "text-sm font-medium" }
const _hoisted_38 = {
  key: 1,
  class: "p-4 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400 rounded-xl border border-red-200 dark:border-red-800"
}
const _hoisted_39 = { class: "flex items-center gap-3" }
const _hoisted_40 = { class: "text-sm font-medium" }
const _hoisted_41 = { class: "bg-blue-50 dark:bg-blue-900/20 p-4 rounded-xl border border-blue-200 dark:border-blue-800" }
const _hoisted_42 = { class: "flex items-start gap-3" }
const _hoisted_43 = { class: "text-sm text-blue-700 dark:text-blue-300" }
const _hoisted_44 = { class: "font-semibold mb-2" }
const _hoisted_45 = { class: "text-sm space-y-1 text-blue-600 dark:text-blue-400" }
const _hoisted_46 = { class: "flex items-center gap-2" }
const _hoisted_47 = { class: "flex items-center gap-2" }
const _hoisted_48 = { class: "flex items-center gap-2" }
const _hoisted_49 = { class: "flex items-center gap-2" }
const _hoisted_50 = { class: "flex items-center justify-between pt-6 border-t border-gray-200 dark:border-slate-600" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_53 = {
  key: 1,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "absolute inset-0 opacity-10" }, [
          _createElementVNode("div", { class: "absolute top-4 right-4 w-32 h-32 rounded-full bg-white/20" }),
          _createElementVNode("div", { class: "absolute -top-8 -right-8 w-24 h-24 rounded-full bg-white/10" }),
          _createElementVNode("div", { class: "absolute bottom-4 left-4 w-20 h-20 rounded-full bg-white/15" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center shadow-lg" }, [
              _createElementVNode("svg", {
                class: "w-8 h-8 text-white",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.directT('settings.changePassword.title')), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.directT('settings.changePassword.subtitle')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_SettingsNav)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-gradient-to-br from-orange-100 to-red-100 dark:from-orange-900/20 dark:to-red-900/20 flex items-center justify-center shadow-inner" }, [
              _createElementVNode("svg", {
                class: "w-5 h-5 text-orange-600 dark:text-orange-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.directT('settings.changePassword.securitySettings')), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.directT('settings.changePassword.securityDescription')), 1)
            ])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)), ["prevent"])),
            class: "space-y-6"
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.directT('settings.changePassword.oldPassword')), 1),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldPassword) = $event)),
                  type: _ctx.showPassword1 ? 'text' : 'password',
                  required: "",
                  class: "w-full px-4 py-3 pr-12 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-slate-900 dark:text-white transition-all duration-200 shadow-sm placeholder:text-slate-400",
                  placeholder: _ctx.directT('settings.changePassword.typePlaceholder')
                }, null, 8, _hoisted_17), [
                  [_vModelDynamic, _ctx.oldPassword]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.togglePasswordVisibility(1))),
                  class: "absolute right-3 top-1/2 -translate-y-1/2 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700"
                }, [
                  (_ctx.showPassword1)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[12] || (_cache[12] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }, null, -1),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[13] || (_cache[13] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                        }, null, -1)
                      ])))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.directT('settings.changePassword.newPassword')), 1),
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPassword) = $event)),
                    type: _ctx.showPassword2 ? 'text' : 'password',
                    required: "",
                    minlength: "6",
                    class: "w-full px-4 py-3 pr-12 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-slate-900 dark:text-white transition-all duration-200 shadow-sm placeholder:text-slate-400",
                    placeholder: _ctx.directT('settings.changePassword.typePlaceholder')
                  }, null, 8, _hoisted_24), [
                    [_vModelDynamic, _ctx.newPassword]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePasswordVisibility(2))),
                    class: "absolute right-3 top-1/2 -translate-y-1/2 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700"
                  }, [
                    (_ctx.showPassword2)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _cache[14] || (_cache[14] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M15 12a3 3 0 11-6 0 3 3 0 616 0z"
                          }, null, -1),
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_26, _cache[15] || (_cache[15] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                          }, null, -1)
                        ])))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.directT('settings.changePassword.confirmPassword')), 1),
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                    type: _ctx.showPassword3 ? 'text' : 'password',
                    required: "",
                    minlength: "6",
                    class: "w-full px-4 py-3 pr-12 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-slate-900 dark:text-white transition-all duration-200 shadow-sm placeholder:text-slate-400",
                    placeholder: _ctx.directT('settings.changePassword.typePlaceholder')
                  }, null, 8, _hoisted_30), [
                    [_vModelDynamic, _ctx.confirmPassword]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.togglePasswordVisibility(3))),
                    class: "absolute right-3 top-1/2 -translate-y-1/2 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700"
                  }, [
                    (_ctx.showPassword3)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_31, _cache[16] || (_cache[16] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M15 12a3 3 0 11-6 0 3 3 0 616 0z"
                          }, null, -1),
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_32, _cache[17] || (_cache[17] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                          }, null, -1)
                        ])))
                  ])
                ]),
                (_ctx.passwordMismatch)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                      _cache[18] || (_cache[18] = _createElementVNode("svg", {
                        class: "w-4 h-4",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.changePassword.passwordsDoNotMatch')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.successMessage || _ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_ctx.successMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "w-8 h-8 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg flex items-center justify-center" }, [
                            _createElementVNode("svg", {
                              class: "w-4 h-4 text-emerald-600 dark:text-emerald-400",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M5 13l4 4L19 7"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.successMessage), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "w-8 h-8 bg-red-100 dark:bg-red-900/30 rounded-lg flex items-center justify-center" }, [
                            _createElementVNode("svg", {
                              class: "w-4 h-4 text-red-600 dark:text-red-400",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M6 18L18 6M6 6l12 12"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.errorMessage), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mt-0.5 flex-shrink-0" }, [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-blue-600 dark:text-blue-400",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.directT('settings.changePassword.passwordSecurityTips')), 1),
                  _createElementVNode("ul", _hoisted_45, [
                    _createElementVNode("li", _hoisted_46, [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-blue-400" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.changePassword.tip1')), 1)
                    ]),
                    _createElementVNode("li", _hoisted_47, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-blue-400" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.changePassword.tip2')), 1)
                    ]),
                    _createElementVNode("li", _hoisted_48, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-blue-400" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.changePassword.tip3')), 1)
                    ]),
                    _createElementVNode("li", _hoisted_49, [
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-blue-400" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.changePassword.tip4')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_RouterLink, {
                to: "/authentication/forgot-password",
                class: "text-sm text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 transition-colors font-medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.directT('settings.changePassword.forgotPassword')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.isLoading || _ctx.passwordMismatch,
                class: "px-6 py-3 text-sm font-medium rounded-xl transition-all duration-200 disabled:cursor-not-allowed flex items-center gap-2 shadow-lg hover:shadow-xl transform hover:scale-105 disabled:hover:scale-100",
                style: _normalizeStyle({
                  color: '#ffffff',
                  background: _ctx.isLoading || _ctx.passwordMismatch ? '#9CA3AF' : 'linear-gradient(to right, #f97316, #dc2626)',
                  opacity: _ctx.isLoading || _ctx.passwordMismatch ? '0.5' : '1'
                }),
                onMouseover: _cache[6] || (_cache[6] = ($event: any) => (!_ctx.isLoading && !_ctx.passwordMismatch && ($event.target.style.background = 'linear-gradient(to right, #ea580c, #b91c1c)'))),
                onMouseout: _cache[7] || (_cache[7] = ($event: any) => (!_ctx.isLoading && !_ctx.passwordMismatch && ($event.target.style.background = 'linear-gradient(to right, #f97316, #dc2626)')))
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_52, _cache[26] || (_cache[26] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M5 13l4 4L19 7"
                      }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_53, _cache[27] || (_cache[27] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ]))),
                _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? _ctx.directT('settings.changePassword.updating') : _ctx.directT('settings.changePassword.updatePassword')), 1)
              ], 44, _hoisted_51)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}